import { enforce, test } from "vest";
import { trans } from "@/service/i18n/i18n";
import { accessFormFieldValue, createFieldName } from "@/forms/form-field";

export function createTextFieldValidationSuite(
  definition: TextField,
  formValue: any,
): void {
  const value = (accessFormFieldValue(definition, formValue) as string) ?? "";

  if (definition.required) {
    test(createFieldName(definition), trans("form_validation.required"), () => {
      enforce(value).isString().isNotEmpty();
    });
  }

  if (definition.regexp && value.length > 0) {
    test(
      createFieldName(definition),
      trans("form_validation.invalid_format"),
      () => {
        enforce(
          !value ||
            value.length === 0 ||
            value.match(definition.regexp as string),
        ).isTruthy();
      },
    );
  }

  if (definition.min && value.length > 0) {
    test(
      createFieldName(definition),
      trans("form_validation.min", { value: definition.min }),
      () => {
        enforce(value).longerThan(definition.min - 1);
      },
    );
  }

  if (definition.max && value.length > 0) {
    test(
      createFieldName(definition),
      trans("form_validation.min", { value: definition.max }),
      () => {
        enforce(value).shorterThan(definition.max);
      },
    );
  }

  if (definition.exact && value.length > 0) {
    test(
      createFieldName(definition),
      trans("form_validation.exact", { value: definition.exact }),
      () => {
        enforce(value.length).equals(definition.exact);
      },
    );
  }
}
